import { api } from './api';
import {
  CustomerCreditInfo,
  CreditCheckResult,
  CreditCheckRequest,
  CustomerOverLimit,
} from '../types/credit.types';

// Uses the shared API client, so requests get the right base URL and login token
class CreditService {
  async getCustomerCreditInfo(customerId: string): Promise<CustomerCreditInfo> {
    const response = await api.get<CustomerCreditInfo>(`/customers/${customerId}/credit-info`);
    return response.data;
  }

  async checkCreditLimit(customerId: string, request: CreditCheckRequest): Promise<CreditCheckResult> {
    const response = await api.post<CreditCheckResult>(`/customers/${customerId}/check-credit`, request);
    return response.data;
  }

  async updateCreditLimit(customerId: string, creditLimit: number): Promise<any> {
    const response = await api.patch(`/customers/${customerId}/credit-limit`, { creditLimit });
    return response.data;
  }

  async getCustomersOverCreditLimit(): Promise<CustomerOverLimit[]> {
    const response = await api.get<CustomerOverLimit[]>('/customers/over-credit-limit');
    return response.data;
  }

  async checkOrderCreditLimit(customerId: string, orderAmount: number): Promise<CreditCheckResult> {
    return this.checkCreditLimit(customerId, {
      orderAmount,
      throwOnExceed: false,
    });
  }
}

export const creditService = new CreditService();
